import React from 'react';
import { css } from '@emotion/react';

import { PauseButtonIcon, PlayButtonIcon } from '$/images/Icons';
import { withWebinarPlayerContext } from '$/components/WebinarPlayer/context';

import Button from '../../ui/Button';

export const PlayButton: React.FC<{
  className?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  invert?: boolean;
  showPlayIcon?: boolean;
}> = withWebinarPlayerContext(
  ['isPlaying'],
  'PlayButton'
)(({ onClick, invert, context, showPlayIcon, className }) => {
  const { isPlaying } = context;
  const onLocalClick = React.useCallback<React.MouseEventHandler<HTMLButtonElement>>(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      onClick(e);
    },
    [onClick]
  );

  return (
    <Button
      id='playButton'
      className={`relative appearence-none flex flex-col items-center justify-center outline-none z-player-control ${className}`}
      css={css`
        width: 100%;
        height: 100%;
        -webkit-tap-highlight-color: transparent;
      `}
      onClick={onLocalClick}
    >
      <div
        className={`relative w-full h-full`}
        css={css`
          & > * {
            width: 100%;
            height: 100% !important;
            border-radius: 50%;
            backdrop-filter: blur(10px);
            &:hover {
              backdrop-filter: blur(15px);
            }

            ${invert
              ? `
                color: #fff !important;
                background: rgba(0,0,0, 0.5);
              `
              : `
                background: rgba(255, 255, 255, 0.5);
            `}
          }
        `}
      >
        {!isPlaying || showPlayIcon ? <PlayButtonIcon /> : <PauseButtonIcon />}
      </div>
    </Button>
  );
});
